import React from "react";
import { useParams, Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { Calendar, ArrowLeft, Tag } from "lucide-react";

export default function BlogDetail() {
    const { slug } = useParams();
    const q = useQuery({ queryKey: ["blog", slug], queryFn: () => api.get(`/blogs/${slug}`).then((r) => r.data) });
    const b = q.data;

    if (q.isLoading) return <div className="p-20 text-muted-foreground">Loading…</div>;
    if (!b) return <div className="p-20 text-muted-foreground">Post not found.</div>;

    return (
        <div data-testid="blog-detail-page">
            <article className="mx-auto max-w-3xl px-5 lg:px-10 py-16">
                <Link to="/blog" className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-primary mb-6">
                    <ArrowLeft className="h-4 w-4" /> All posts
                </Link>
                <div className="font-eyebrow text-xs text-secondary mb-4">{b.tags?.[0] || "Blog"}</div>
                <h1 className="font-display text-4xl lg:text-6xl leading-[1.05] tracking-tight">{b.title}</h1>
                <div className="mt-5 flex items-center gap-4 text-sm text-muted-foreground">
                    <span className="flex items-center gap-1.5"><Calendar className="h-4 w-4" />{new Date(b.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</span>
                    {b.tags?.length > 0 && (
                        <span className="flex items-center gap-1.5">
                            <Tag className="h-4 w-4" /> {b.tags.join(", ")}
                        </span>
                    )}
                </div>
                {b.featured_image && (
                    <img src={b.featured_image} alt={b.title} className="mt-8 w-full aspect-[16/9] object-cover" />
                )}
                <div
                    className="mt-10 prose-content text-base text-foreground/85"
                    dangerouslySetInnerHTML={{ __html: b.content }}
                />
            </article>
        </div>
    );
}
